var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUpBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 5,
    viewBox: "0 0 7 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00001 0.238912C3.05883 0.162177 3.13453 0.10001 3.22123 0.0572258C3.30794 0.0144414 3.40333 -0.0078125 3.50001 -0.0078125C3.5967 -0.0078125 3.69209 0.0144414 3.77879 0.0572258C3.8655 0.10001 3.94119 0.162177 4.00001 0.238912L6.80001 3.48891C6.90787 3.605 6.98316 3.74751 7.01828 3.90203C7.0534 4.05655 7.0471 4.21761 7.00001 4.36891C6.95842 4.51111 6.87339 4.63674 6.75683 4.72819C6.64027 4.81965 6.49802 4.87235 6.35001 4.87891H0.700013C0.552421 4.8709 0.41087 4.81766 0.294583 4.72642C0.178296 4.63518 0.0929073 4.51036 0.0500134 4.36891C-0.00173252 4.22156 -0.0151146 4.06346 0.0111279 3.9095C0.0373703 3.75554 0.102373 3.6108 0.200013 3.48891L3.00001 0.238912Z",
    fill: "#0084FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpBlue);
export default __webpack_public_path__ + "static/media/chevron-up-blue.1567202dc1cd93f56027bdb9e3a3238f.svg";
export { ForwardRef as ReactComponent };